/* Reference photo framing is used only for an exact known Shopify image revision. */
(()=>{'use strict';
 let images={};
 try{images=JSON.parse(document.getElementById('tsw-reference-media-map')?.textContent||'{}')}catch{}
 window.TSwitchMedia={url(src){
  if(!src)return '';
  try{
   const original=new URL(src,location.origin);
   const name=decodeURIComponent(original.pathname.split('/').pop());
   const key=name+'?v='+original.searchParams.get('v');
   return images[key]||src;
  }catch{return src}
 }};
})();
